<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onSelectedVendor'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.거래처명}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refInventoryGrid'
          :data-source='inventoryReceiptInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :focused-row-key.sync='focusedRowKey'
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @toolbar-preparing='onToolbarPreparing'
          @row-updated='onRowUpdated' @row-updating="onRowUpdating"
          @row-removed='onRowRemoved' @row-removing='onRowRemoving'
          @editor-preparing='onEditorPreparing'
          @cell-prepared='onCellPreparedOutput'
          @rowDblClick ='onRowDbClick'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="exportTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="isDeletable"
            :allow-updating="isEditable"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          />
          <DxSelection mode="single"
            show-check-boxes-mode="always"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="처리일"
            data-field="발생일"
            dataType='date'
            sort-order='asc'
            format='yyyy-MM-dd'>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="false"
            caption="처리일시"
            data-field="발생일자"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm:ss'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="고객사"
            data-field="거래처명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="차종"
            data-field="차종"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="납입품번"
            data-field="납입품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="공정유형"
            data-field="공정유형"
            :visible='true'
          >
            <DxLookup
              :data-source="processingTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="자재유형"
            data-field="자재유형"
            :visible='true'
          >
            <DxLookup
              :data-source="meterialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구분"
            data-field="입출고구분"
            :visible='true'
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="수량"
            data-field="합계수량"
            dataType='number'
            :visible='true'
            format='#,##0'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="판매단가"
            data-field="가격"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="판매금액"
            data-field="판매금액"
            :calculate-cell-value="calcAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="파레트번호"
            data-field="입고키"
            dataType="number"
          >
          </DxColumn>

          <DxColumn
            :allowEditing='false'
            caption="등록자"
            data-field="성명"
            :visible='true'
          >
            <DxLookup
              :data-source="등록자리스트"
              display-expr="성명"
              value-expr="성명"
            />
          </DxColumn>
          <DxColumn
            width="90"
            :buttons="editSubButtons"
            type="buttons"
          />
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="합계수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="판매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <DxPopup
        :visible.sync="deleteOutputPopup"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-title="true"
        :width="700"
        :height="250"
        title="출하 삭제목록"
      >
        <dx-data-grid ref='refDeleteOutputPopupGrid'
          :data-source='deleteOutputList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :row-alternation-enabled="true"
          :focused-row-enabled="false"
          :auto-navigate-to-focused-row="false"
          :height="180"
        >
          <DxEditing
            :allow-deleting="false"
            :use-icons="true"
            mode="row"
            />
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="처리일"
            data-field="발생일"
            dataType='date'
            sort-order='asc'
            format='yyyy-MM-dd'
            :visible='false'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="false"
            caption="처리일시"
            data-field="발생일자"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm:ss'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="공정유형"
            data-field="공정유형"
            :visible='false'
          >
            <DxLookup
              :data-source="processingTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품목유형"
            data-field="품목유형"
            :visible='false'
          >
            <DxLookup
              :data-source="itemTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구분"
            data-field="입출고구분"
            :visible='false'
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="수량"
            data-field="수량"
            dataType='number'
            :visible='true'
            format='#,##0'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="파레트번호"
            data-field="입고키"
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="출하차량"
            data-field="출하차량"
            :visible='false'
          >
          </DxColumn>
          <DxColumn
            width="45"
            :buttons="popupEditButtons"
            type="buttons"
          />
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </DxPopup>
      <DxPopup
        :visible.sync="inputListPopup"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-title="true"
        :width="700"
        :height="250"
        title="입고목록">
        <dx-data-grid ref='refDeleteOutputPopupGrid'
          :data-source='inputList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :row-alternation-enabled="true"
          :focused-row-enabled="false"
          :auto-navigate-to-focused-row="false"
          :height="180"
        >
          <DxEditing
            :allow-deleting="false"
            :use-icons="true"
            mode="row"
            />
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="발생일자"
            data-field="발생일자"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm:ss'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품명"
            data-field="품명"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="자재유형"
            data-field="자재유형"
            :visible='false'
          >
            <DxLookup
              :data-source="meterialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="수량"
            data-field="수량"
            dataType='number'
            :visible='true'
            format='#,##0'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="파레트번호"
            data-field="입고키"
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            v-if="isPurchase"
            :allowEditing='false'
            caption="입고업체"
            data-field="입고업체"
          >
            <DxLookup
              :data-source="companyLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="수량"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </DxPopup>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import { DxPopup } from 'devextreme-vue/popup'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup, DxSelection,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport, DxEditing } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import axios from 'axios'

export default {
  name: 'production-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '제품출하현황'
        }
      ],
      inventoryReceiptInfo: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      focusedRowKey: null,
      editSubButtons: ['edit', 'delete'],
      selectedVendor: null,
      processingTypeLookup: null,
      meterialTypeLookup: null,
      isGroupByGoodsCode: false,
      carList: [],
      deleteOutputPopup: false,
      inputListPopup: false,
      inputList: [],
      companyLookup: [],
      deleteOutputList: [],
      popupEditButtons: ['delete',
        {
          hint: '복구',
          icon: 'refresh',
          visible: 'true',
          onClick: this.onRevert
        }
      ],
      등록자리스트: [],
      popupInItemType: false,
      deleteListBtn: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxEditing,
    DxRequiredRule,
    DxSelection,
    DxPopup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.companyLookup = this.$store.getters.getCompanyInfo
    console.log(this.companyLookup)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.receiptTypeLookup = ConstDef.PRODUCTION_INOUT_CODE
    this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
  },
  computed: {
    isPurchase () {
      return this.popupInItemType === ConstDef.구매품
    }
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    calcAmount (row) {
      return row.합계수량 * row.가격
    },
    isEditable (row) {
      let result = AppLib.isInOutCRUDable(row.row.data.발생일자)
      if (result === false) {
        return result
      } else {
        if (this.isGroupByGoodsCode) {
          result = !this.isGroupByGoodsCode
        }
        return result
      }
    },
    isDeletable (row) {
      let result = AppLib.isInOutCRUDable(row.row.data.발생일자)
      if (result === false) {
        this.deleteListBtn.option({ disabled: true })
      } else {
        this.deleteListBtn.option({ disabled: false })
        if (this.isGroupByGoodsCode) {
          result = !this.isGroupByGoodsCode
        }
      }
      return result
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (e.data.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품반품' }).코드) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
    },
    onClickPrintReceipt (e) {

    },
    onEditorPreparing (e) {
    },
    onRowDbClick (row) {
      this.inputListPopup = true
      this.popupInItemType = row.data.품목유형
      let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        startDate: `${this.thisYear}-${this.thisMonth}-01`,
        endDate: `${endDate}`,
        품번: row.data.품번
      }
      console.log(param)
      this.$_sp.runNoEncodeFindProc('spFindAllInputAndProduceListByDateAndPcode', param)
        .then((data) => {
          this.isLoading = false
          this.inputList = this.$_sp.MakeModel(data)
          console.log(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (row) {
      if (this.isGroupByGoodsCode) {
        this.$snotify.error('품목별 합계 상태에선 삭제 할 수 없습니다.')
        row.cancel = true
      }
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runDeleteProc('spInsertAndDeleteInOutListBySeqId', [{ seqId: row.data.seqId, isInsert: true }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      console.log(row.data)
      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, [{ seqId: row.data.seqId, 수량: row.data.합계수량, 발생일자: row.data.발생일자 }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      console.log(row)
      // if (row.oldData.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품출하' }).코드) {
      //   if (row.newData.출하차량 !== undefined && row.newData.출하차량.length === 0) {
      //     this.$snotify.error('납품챠량 번호를 입력하여 주세요')
      //     row.cancel = true
      //   }
      // }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.isGroupByGoodsCode,
            text: '품목별 합계',
            onValueChanged: (args) => {
              this.isGroupByGoodsCode = args.value
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '삭제목록',
            icon: 'trash',
            text: '삭제목록',
            type: 'default',
            focusStateEnabled: true,
            onInitialized: args => {
              this.deleteListBtn = args.component
            },
            onClick: (args) => {
              this.popupDeleteListOn()
            }
          }
        }
      )
    },
    refreshInventoryList () {
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-제품출하현황`
      if (this.isGroupByGoodsCode) {
        this.inventoryReceiptInfo = this.$store.getters.getProductOutputListGby(this.selectedVendor)
      } else {
        this.inventoryReceiptInfo = this.$store.getters.getProductOutputList(this.selectedVendor)
      }
      if (this.inventoryReceiptInfo === null) {
        this.getInventoryReceiptInfo()
      }
    },
    getInventoryReceiptInfo () {
      this.isLoading = true
      let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        startDate: `${this.thisYear}-${this.thisMonth}-01`,
        endDate: `${endDate}`,
        품목유형: ConstDef.완제품,
        자재유형: null,
        거래처코드: this.selectedVendor,
        마감: 0
      }
      const list = this.$_sp.runNoEncodeFindProc('spFindAllInventoryReceiptByDateAndGoodsType', param)
      const listGby = this.$_sp.runNoEncodeFindProc('spFindAllProductOutputByDateGbyVendorGoodNo', param)
      axios.all([list, listGby])
        .then(axios.spread((...reponse) => {
          this.isLoading = false
          const inventoryReceiptInfo = this.$_sp.MakeModel(reponse[0])
          const inventoryReceiptInfoGbyVendorGoodsNo = this.$_sp.MakeModel(reponse[1])
          if (this.isGroupByGoodsCode) {
            this.inventoryReceiptInfo = inventoryReceiptInfoGbyVendorGoodsNo
          } else {
            this.inventoryReceiptInfo = inventoryReceiptInfo
          }
          const gById = this.$_.groupBy(this.inventoryReceiptInfo, function (num) { return num.성명 })
          let array = Object.keys(gById)
          for (var i in array) {
            this.등록자리스트.push({ 성명: array[i] })
          }
          this.$store.commit('savePurchaseInoutList', { data: inventoryReceiptInfo, option: param })
          this.$store.commit('saveOutListGby', { data: inventoryReceiptInfoGbyVendorGoodsNo, option: param })
          console.log(inventoryReceiptInfo)
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onSelectedVendor () {
      this.selectedVendor = this.tabs[this.selectedIndex].입고업체
      this.refreshInventoryList()
    },
    refreshVendorList (date) {
      const param = {
        toDate: `${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`,
        fromDate: `${date}-01`,
        자재유형: null,
        입출고구분: ConstDef.제품출하
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInputVendorList', param)
        .then((data) => {
          this.tabs = this.$_sp.MakeModel(data)
          this.tabs.unshift({ 거래처명: 'ALL', 입고업체: 'ALL' })
          console.log(this.tabs[0].입고업체)
          this.selectedVendor = this.tabs[0].입고업체
          this.refreshInventoryList()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // pop Start
    popupDeleteListOn (e) {
      this.refreshDeleteOutPutList()
      this.deleteOutputPopup = true
    },
    refreshDeleteOutPutList () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindSqlProc('TEMP_창고수불', null)
        .then((data) => {
          this.deleteOutputList = this.$_sp.MakeModel(data)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRevert (e) {
      this.$snotify.confirm('삭제된 데이터를 복구하시겠습니까?', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '복구',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.isLoading = true
              this.$_sp.runDeleteProc('spInsertAndDeleteInOutListBySeqId', [{ seqId: e.row.data.seqId, isInsert: false }])
                .then((data) => {
                  this.isLoading = false
                  this.deleteOutputList.splice(this.$_.findIndex(this.deleteOutputList, { seqId: e.row.data.seqId }), 1)
                  this.getInventoryReceiptInfo()
                })
                .catch(error => {
                  this.isLoading = false
                  if (error.response.status === ConstDef.GENERRAL_ERROR) {
                    this.$snotify.error(error.response.data.message)
                  } else {
                    this.$snotify.error(`에러코드 : ${error.response.status}`)
                  }
                })
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss">

</style>
